module.exports = __webpack_public_path__ + "static/media/10.bf67f124.wav";


//////////////////
// WEBPACK FOOTER
// ./src/audio/row1/10.wav
// module id = 38
// module chunks = 0